import styled, { css } from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';

interface StyleProps {
  marginTopDesktop?: number;
  marginBottomDesktop?: number;
  marginTopTablet?: number;
  marginBottomTablet?: number;
  marginTopMobile?: number;
  marginBottomMobile?: number;
  showAccordian?: boolean;
}

export const VehicleDetailsPageWrapper = styled.div``;

export const Container = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  padding: 0 0 72px 0;
`;

export const SectionTitle = styled.div`
  h2 {
    display: block;
    font-weight: 700;
    line-height: 36px;
    padding: 0 18px;
    font-size: 24px;
    margin-bottom: 24px;
    @media ${device.tablet} {
      display: block;
      line-height: 42px;
      font-size: 28px;
      margin-bottom: 44px;
      padding: 0 0px;
    }
    @media ${device.laptop} {
      line-height: 54px;
      font-size: 36px;
    }
    @media ${device.laptopL} {
      line-height: 60px;
      font-size: 40px;
    }
  }
`;

export const Wrapper = styled(VehicleDetailsPageWrapper)`
  width: 100%;
  margin: 0;
  @media ${device.mobileS} {
    margin-top: ${({ marginTopMobile }: StyleProps) =>
      marginTopMobile ? `${marginTopMobile}px` : '0px'};
    margin-bottom: ${({ marginBottomMobile }: StyleProps) =>
      marginBottomMobile ? `${marginBottomMobile}px` : '0px'};
  }
  @media ${device.tablet} {
    width: calc(100% - 120px);
    margin: 0 auto 96px auto;
    margin-top: ${({ marginTopTablet }: StyleProps) =>
      marginTopTablet ? `${marginTopTablet}px` : '0px'};
    margin-bottom: ${({ marginBottomTablet }: StyleProps) =>
      marginBottomTablet ? `${marginBottomTablet}px` : '0px'};
  }
  @media ${device.laptopL} {
    width: calc(100% - 192px);
    margin: 0 auto 96px auto;
    margin-top: ${({ marginTopDesktop }: StyleProps) =>
      marginTopDesktop ? `${marginTopDesktop}px` : '0px'};
    margin-bottom: ${({ marginBottomDesktop }: StyleProps) =>
      marginBottomDesktop ? `${marginBottomDesktop}px` : '0px'};
  }
  @media ${device.desktop} {
    max-width: 1248px;
    margin: 0 auto 96px auto;
    margin-top: ${({ marginTopDesktop }: StyleProps) =>
      marginTopDesktop ? `${marginTopDesktop}px` : '0px'};
    margin-bottom: ${({ marginBottomDesktop }: StyleProps) =>
      marginBottomDesktop ? `${marginBottomDesktop}px` : '0px'};
  }
  ${({ showAccordian }: StyleProps) => {
    return css`
      background: ${showAccordian ? COLORS.audiGrayFive : 'transparent'};
      @media ${device.tablet} {
        background: transparent;
      }
    `;
  }}
`;
